<template>
  <Image :src="src" alt="image not found" :imageStyle="imageStyle" preview />
</template>

<script>
import Image from "primevue/image";

export default {
  name: "PrimeVueImage",

  components: { Image },

  props: {
    src: {
      type: String,
    },
    imageStyle: {
      type: String,
      default: "max-width: 100%; max-height: 100%;",
    },
  },
};
</script>

<style>
.p-image-action.p-link {
  color: white !important;
}

.p-image-preview-indicator {
  color: black !important;
  transition: opacity 0.3s;
}
</style>
